import clsx from "clsx";
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";
import { ReactElement } from "react";
import useDarkMode from "../../hooks/useDarkMode";
import { MdDarkMode, MdLightMode } from "react-icons/md";
import { ICON_SIZES } from "../../helpers/constants";
import ButtonGroup from "../../components/ButtonGroup/ButtonGroup";
import { Link } from "react-router-dom";
import ExpenserTriangle from "../../components/ExpenserTriangle/ExpenserTriangle";

interface IInternalPage {
  children: ReactElement;
  title?: any;
  description?: any;
}

const InternalPage: React.FC<IInternalPage> = ({
  children,
  title,
  description,
}) => {
  const { isEnabled, setEnabled } = useDarkMode();

  return (
    <>
      <div className={clsx(["flex", "w-full", "flex-col"])}>
        <div
          className={clsx([
            "flex",
            "w-full",
            "items-center",
            "flex-col",
            "justify-center",
            "bg-[#0e223f] dark:bg-gray-900",
            "gap-5",
            "md:gap-0",
            "md:py-0",
            "text-white",
            "sticky",
            "top-0",
          ])}
        >
          <div className={clsx(["flex", "w-full", "hidden"])}>
            <ButtonGroup
              align="left"
              buttons={[
                {
                  icon: (
                    <MdDarkMode
                      size={ICON_SIZES.SM}
                      className="text-purple-400"
                    />
                  ),
                  hide: isEnabled,
                  onClick: () => setEnabled(!isEnabled),
                  className: "!shadow-none !border-0 !bg-transparent",
                },
                {
                  icon: (
                    <MdLightMode
                      size={ICON_SIZES.SM}
                      className="text-yellow-400"
                    />
                  ),
                  hide: !isEnabled,
                  onClick: () => setEnabled(!isEnabled),
                  className: "!shadow-none !border-0 !bg-transparent",
                },
              ]}
            />
            <LanguageSwitcher />
          </div>
          <div
            className={clsx([
              "flex",
              "w-full",
              "gap-4",
              "md:gap-5",
              "items-center",
              "items-end",
              "justify-between",
              // "justify-start",
              "md:max-w-4xl",
              "md:mx-auto",
              "px-4",
              "md:px-6",
              "py-2",
              "md:flex-row",
              // "flex-col",
            ])}
          >
            <Link
              to="/"
              onClick={() => {}}
              className={clsx([
                "inline-flex",
                "flex-row",
                "items-center",
                "md:justify-end",
                "gap-1",
              ])}
            >
              <ExpenserTriangle size={22} className={clsx(["text-red-600"])} />
              <h1 className={clsx(["text-xl", "font-medium", "text-white"])}>
                eXpenser
                <span
                  className={clsx([
                    "text-[11px]",
                    "uppercase",
                    "text-red-600",
                    {
                      hidden: false, //isPwa(),
                    },
                  ])}
                >
                  .net
                </span>
              </h1>
            </Link>
            <div
              className={clsx([
                "italic",
                "flex",
                "text-xs",
                "sm:text-base",
                "text-right",
                "max-w-[203px]",
                "sm:max-w-none",
                // "md:max-w-max",
              ])}
            >
              <div>
                The most flexible
                <strong className="mx-1">Income and Expenses Tracking</strong>
                tool.
              </div>
            </div>
          </div>
        </div>
        <div
          className={clsx([
            "w-full",
            "flex",
            "justify-start",
            "flex-col",
            "md:max-w-4xl",
            "md:mx-auto",
          ])}
        >
          <div
            className={clsx([
              "flex",
              "flex-col",
              "gap-6",
              "w-full",
              "md:w-auto",
              "p-4",
              "md:p-6",
            ])}
          >
            {[!!title || !!description].includes(true) === true && (
              <div className={clsx(["flex", "gap-2", "flex-col", "w-full"])}>
                <h1 className={clsx(["text-xl", "md:text-3xl", "font-medium"])}>
                  {title}
                </h1>
                {description && (
                  <p className={clsx(["text-sm", "md:text-base"])}>
                    {description}
                  </p>
                )}
              </div>
            )}
            {children}
            <div
              className={clsx([
                "flex",
                "text-xs",
                "md:text-sm",
                "md:mt-10",
                "flex-col",
                "md:flex-row",
              ])}
            >
              <div
                className={clsx([
                  "flex",
                  "w-full",
                  "md:gap-4",
                  "gap-2",
                  "flex-row",
                  // "flex-col",
                  "md:items-end",
                  "md:justify-end",
                  "justify-around",
                  "pb-4",
                  "md:pb-0",
                ])}
              >
                <Link to="/" className="underline hover:opacity-90">
                  Inicio
                </Link>
                <Link
                  to="/privacy-policy"
                  className="underline hover:opacity-90"
                >
                  Política de Privacidad
                </Link>
                <Link
                  to="/terms-and-conditions"
                  className="underline hover:opacity-90"
                >
                  Términos y Condiciones
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InternalPage;
